import React, { useState, useEffect } from 'react';
import Header from '../components/header';
import MainMenu from '../components/mainmenu';
import WorkOrderList from '../components/workorderlist';
import SchedulingCalendar from '../components/scheduling/schedulingcalendar';
import PageMenu from '../components/pagemenu';
import './retail.css';

import Archived from '../components/archived';

function Retail() {
  const [isAuthenticated, setIsAuthenticated] = useState(false);
  const [activeComponent, setActiveComponent] = useState('workOrderList');


  useEffect(() => {
    // Check for auth token in localStorage on component mount
    const token = localStorage.getItem('authToken');
    if (token) {
      setIsAuthenticated(true);
    }
  }, []);


  return (
    <div className="App">
      <Header isAuthenticated={isAuthenticated} setIsAuthenticated={setIsAuthenticated} />
      {isAuthenticated ? (
        <div className='content'>
        <MainMenu setActiveComponent={setActiveComponent} />
        {activeComponent === 'workOrderList' && <WorkOrderList />}
        {activeComponent === 'scheduling' && <SchedulingCalendar />}
        {activeComponent === 'archived' && <Archived />}
        
      </div>
      ) : (
        <div>Please log in to view content</div>
      )}
      {/* Bottom navigation for mobile */}
      <PageMenu className="bottom-nav" />
    </div>
  );
}

export default Retail;